// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-41df4284] .el-tabs__nav-scroll {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.container[data-v-41df4284] {\n  background-color: #fff;\n  padding: 0.1rem;\n}\n.container .header[data-v-41df4284] {\n    display: flex;\n    justify-content: center;\n}\n", ""]);
// Exports
module.exports = exports;
